import React, { useEffect } from 'react'
import clsx from 'clsx'
import { BreadCrumbItemProps } from '@/components/breadcrumbs/BreadcrumbItem'
import { useAppContext } from './AppContext'
import { FixMeLater } from '../types'
import { Footer } from './Footer'
import SubHeader from './SubHeader'

export type PageProps = {
	children: React.ReactNode
	page?: string
	title?: string
	isFullWidth?: boolean
	noDarkMode?: boolean
	showFooter?: boolean
	bgColor?: string
	bgImageUrl?: string
	breadcrumbs?: BreadCrumbItemProps[]
	hideSubHeader?: boolean
}

const getPageTitle = (name: string, title?: string) => {
	if (title && name) return `${name} - ${title}`
	if (title) return title
	return name
}

export default function Page({
	children,
	page = '',
	title,
	isFullWidth = false,
	noDarkMode = false,
	showFooter = false,
	hideSubHeader = false,
	breadcrumbs,
	bgColor,
	bgImageUrl,
}: Readonly<PageProps>) {
	const { state } = useAppContext()
	const { siteConfig, legalLinks, socialLinks } = state

	useEffect(() => {
		const titleName = (siteConfig as FixMeLater)?.name ?? ''

		document.title = getPageTitle(titleName, title)
	}, [title, siteConfig])

	return (
		<div className="px-5">
			{!hideSubHeader && <SubHeader breadcrumbs={breadcrumbs} />}
			<div className={clsx(!noDarkMode && 'dark:bg-[#121212]')}>
				{!!(bgColor || bgImageUrl) && (
					<div
						className="bg-cover bg-center absolute top-0 left-0 w-full h-full -z-10"
						style={{
							backgroundColor: bgColor,
							backgroundImage: bgImageUrl
								? `url(${bgImageUrl})`
								: undefined,
						}}
					/>
				)}
				<div
					className={clsx(
						'mx-auto',
						page,
						!isFullWidth && 'max-w-screen-xl',
						!noDarkMode && 'dark:bg-[#121212]'
					)}
				>
					{children}
				</div>
				{showFooter && (
					<Footer
						siteConfig={siteConfig as FixMeLater}
						socialLinks={socialLinks}
						legalLinks={legalLinks}
					/>
				)}
			</div>
		</div>
	)
}
